/* eslint-disable */

/** unique or primary key constraints on table "argo.material_model" */
export enum ArgoMaterialModelConstraint {
  /** unique or primary key constraint on columns "context_id", "is_default" */
  MaterialModelIsDefaultCnstrnt = 'material_model_is_default_cnstrnt',
  /** unique or primary key constraint on columns "material_model_id" */
  MaterialModelPkey = 'material_model_pkey'
}

/** select columns of table "argo.material_model" */
export enum ArgoMaterialModelSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  LinkedMedia = 'linked_media',
  /** column name */
  LinkedProfilePicture = 'linked_profile_picture',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  ModelNumber = 'model_number',
  /** column name */
  ProfileFileId = 'profile_file_id',
  /** column name */
  SnFormatId = 'sn_format_id',
  /** column name */
  SnValidationPattern = 'sn_validation_pattern',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_material_model_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.material_model" */
export enum ArgoMaterialModelSelectColumnArgoMaterialModelAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  IsDefault = 'is_default'
}

/** select "argo_material_model_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.material_model" */
export enum ArgoMaterialModelSelectColumnArgoMaterialModelAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  IsDefault = 'is_default'
}

/** update columns of table "argo.material_model" */
export enum ArgoMaterialModelUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  LinkedMedia = 'linked_media',
  /** column name */
  LinkedProfilePicture = 'linked_profile_picture',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  ModelNumber = 'model_number',
  /** column name */
  ProfileFileId = 'profile_file_id',
  /** column name */
  SnFormatId = 'sn_format_id',
  /** column name */
  SnValidationPattern = 'sn_validation_pattern',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

